<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><span class="small">BARRY HANNAH’S</span></p>
<p class="textcenter"><strong>AIRSHIPS</strong></p>
<p class="noindent">“Exhilarating! Hannah is afraid of nothing in experience. He runs to meet life and to transform it.”</p>
<p class="center">—<span class="small">DENIS DONOGHUE</span></p>
<p class="noindent">“Barry Hannah’s writing is raw and exhilarating, tortured, radiant, vicious, aggressive, funny and streaked with rage, pain and bright, poetic truth.”</p>
<p class="center">—THE PHILADELPHIA INQUIRER</p>
<p class="noindent">“Hannah’s stories are powerful, and powerfully original.”</p>
<p class="center">—<span class="small">JOHN GARDNER</span></p>
<p class="noindent">“Barry Hannah is an original, vital talent.”</p>
<p class="center">—THE HOUSTON CHRONICLE</p>
<p class="noindent">“The best young writer to appear in the South since Flannery O’Connor.”</p>
<p class="center">—<span class="small">LARRY MCMURTRY</span></p>
<p class="noindent"><a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?6172f3cd